import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-20">
        <h1 className="font-serif text-4xl md:text-5xl text-charcoal mb-4" data-testid="privacy-policy-title">
          Privacy Policy
        </h1>

        <p className="text-sm text-[#6B665F] mb-2">
          Siyaanish – Live Your Values
        </p>
        {/* <p className="text-sm text-[#6B665F] mb-8">
          Last updated: [Add Date]
        </p> */}

        <p className="text-[#6B665F] leading-relaxed mb-12">
          Siyaanish (“site”, “we”, “our”, “us”) is committed to protecting your privacy and ensuring
          transparency in how your personal information is collected and used.
          This Privacy Policy explains how we collect, use, store, and protect your information when
          you visit or shop on our website.
        </p>

        <div className="space-y-10 text-[#6B665F] leading-relaxed font-light">

          {/* 1 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              1. Information We Collect
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Personal details (name, email address, phone number)</li>
              <li>Shipping and billing address</li>
              <li>Payment information (processed securely via third-party payment gateways)</li>
              <li>Order history and preferences</li>
              <li>Technical data such as IP address, browser type, and device information</li>
            </ul>
          </section>

          {/* 2 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              2. How We Use Your Information
            </h2>
            <p className="mb-2">Your information is used only to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Process and fulfil orders</li>
              <li>Communicate order updates and customer support</li>
              <li>Improve website functionality and user experience</li>
              <li>Comply with legal and regulatory requirements</li>
            </ul>
            <p className="mt-3 font-medium">
              We do not sell, rent, or trade your personal data.
            </p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              3. Payment Security
            </h2>
            <p>
              All payments are processed through secure third-party payment gateways.
              Siyaanish does not store or have access to your complete payment details.
            </p>
          </section>

          {/* 4 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              4. Data Sharing
            </h2>
            <p className="mb-2">We may share limited information with:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Courier and logistics partners (for delivery purposes)</li>
              <li>Payment service providers</li>
              <li>Legal authorities, if required by law</li>
            </ul>
            <p className="mt-3">
              All third parties are obligated to protect your data.
            </p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              5. Cookies
            </h2>
            <p>
              Our website may use cookies to enhance browsing experience and analyse traffic.
              You may disable cookies through your browser settings if preferred.
            </p>
          </section>

          {/* 6 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              6. Data Protection
            </h2>
            <p>
              We implement reasonable security measures to protect your personal information.
              However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          {/* 7 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              7. Your Rights
            </h2>
            <p className="mb-2">You may:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Request access to your personal data</li>
              <li>Request correction or deletion (subject to legal obligations)</li>
            </ul>
            <p className="mt-3">
              To exercise these rights, contact us at{' '}
              <a
                href="mailto:info@siyaanish.com"
                className="text-bronze hover:text-bronze-dark"
              >
                manisha@siyaanish.com
              </a>
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              8. Changes to This Policy
            </h2>
            <p>
              We reserve the right to update this Privacy Policy at any time.
              Continued use of the website indicates acceptance of the updated policy.
            </p>
          </section>

          {/* 9 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              9. Contact
            </h2>
            <p>
              For privacy-related concerns, contact:{' '}
              <a
                href="mailto:info@siyaanish.com"
                className="text-bronze hover:text-bronze-dark"
              >
                info@siyaanish.com
              </a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;